var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "31px",
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Round/Entries-(1)",
    transform: "translate(-692.000000, -261.000000)",
    fill: "#015597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(660.146203, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.853797, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4719101,22.475 L21.8258427,15.5 L12.4719101,8.525 L12.4719101,22.475 L12.4719101,22.475 Z M15.5898876,0 C6.98426966,0 0,6.944 0,15.5 C0,24.056 6.98426966,31 15.5898876,31 C24.1955056,31 31.1797753,24.056 31.1797753,15.5 C31.1797753,6.944 24.1955056,0 15.5898876,0 L15.5898876,0 Z M15.5898875,28.8884682 C8.16349714,28.8884682 2.11797753,22.8778057 2.11797753,15.4942341 C2.11797753,8.11066256 8.16349714,2.1 15.5898875,2.1 C23.0162779,2.1 29.0617975,8.11066256 29.0617975,15.4942341 C29.0617975,22.8778057 23.0162779,28.8884682 15.5898875,28.8884682 L15.5898875,28.8884682 Z",
    id: "Fill-112"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.4f18f370c0319b12732daf556058400d.svg";
export { ForwardRef as ReactComponent };